import {useMutation} from '@tanstack/react-query';
import {toast} from '@ui/toast/toast';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

interface SubmitFeedbackPayload {
  message: string;
  severity: 'Minor' | 'Bug' | 'Blocker';
  page_url?: string;
}

interface Feedback {
  id: number;
  message: string;
  severity: string;
  page_url?: string;
  created_at: string;
}

interface SubmitFeedbackResponse extends BackendResponse {
  feedback: Feedback;
  message: string;
}

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (payload: SubmitFeedbackPayload) =>
      submitFeedback(payload),
    onSuccess: (response) => {
      toast(response.message || 'Thank you for your feedback!');
    },
    onError: (err: any) => {
      const message = err?.message || 'Failed to submit feedback. Please try again.';
      toast.danger(message);
    },
  });
}

function submitFeedback(
  payload: SubmitFeedbackPayload
): Promise<SubmitFeedbackResponse> {
  return apiClient
    .post('feedback', {
      ...payload,
      page_url: payload.page_url || window.location.href,
    })
    .then(r => r.data);
}
